import React from 'react';

import "./NotFound.scss";

const NotFound = () => {
  return (
    <div className="not-found">
      <h2>404 Not Found</h2>
      <p>Sorry, the page you are looking for does not exist.</p>
    </div>
  );
};

export default NotFound;
